import {
  Action,
  ThunkAction,
  applyMiddleware,
  compose,
  createStore
} from '@reduxjs/toolkit'
import ReduxThunk, { ThunkDispatch } from 'redux-thunk'
import rootReducer, { OriginalRootState } from './rootReducer'

/** Explicit type for window */
interface WindowWithReduxExtension extends Window {
  __REDUX_DEVTOOLS_EXTENSION_COMPOSE__?: <R>(a: R) => R
}

/* eslint-disable no-underscore-dangle */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const configureStore = (): any => {
  const composeEnhancers =
    process.env.NODE_ENV !== 'production'
      ? (window as WindowWithReduxExtension)
          .__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose
      : compose

  const enhancers = composeEnhancers(applyMiddleware(ReduxThunk))

  return createStore(rootReducer, enhancers)
}

const store = configureStore()

const rootState = store.getState()
export type RootState = typeof rootState
export type AppDispatch = typeof store.dispatch
export type AppThunkAction<ReturnType = void> = ThunkAction<
  ReturnType,
  OriginalRootState,
  unknown,
  Action<string>
>

export type AppThunkDispatch = ThunkDispatch<
  OriginalRootState,
  // asynchronous function's parameter type
  undefined,
  // the types of all the actions that will be fired by this dispatch
  Action
>

export default store
